import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";


const OrganizationInfo = ({ EmployeeBasicDetails }) => {


  const hasRequiredData = EmployeeBasicDetails?.some(
    (data) =>
      data.KeyCategoryId == 103 ||
      data.OEKId != 121 ||
      data.OEKId != 112 ||
      data.OEKId != 104
  );

  return (
    <div className="mb-2">
      {hasRequiredData ? (
        <div className="form-head stuck-headers33 mt-3">
          <div className="form-head stuck-header profile-about-me">
            <div className="mb-0">
              <h4 className="text-primary mb-3 sumh4 addprofile-action">
                Organization Info
              </h4>

              <div className="languages-wrapper90">
                {EmployeeBasicDetails?.filter(
                  (data) =>
                    data.KeyCategoryId === 103 &&
                    data.OEKId !== 121 &&
                    data.OEKId !== 112 &&
                    data.OEKId !== 104
                )
                  .sort((a, b) => a.KeyDisplayOrder - b.KeyDisplayOrder)
                  .map((data) => (
                    <>
                      {data.InferredValue != "" &&
                        data.InferredValue != null && (
                          <div className="languages-item" key={data.Id}>
                            <div className="icon-wrap">
                              <LazyImage src={data?.Icon} />
                            </div>
                            <div className="meta">
                              <span className="dark-inverted">
                                {data.KeyDesc}
                              </span>
                              <span>{data.InferredValue}</span>
                            </div>
                          </div>
                        )}
                    </>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default OrganizationInfo;
